// @flow
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '@theme';

const { colors } = theme;

export const StyledWrapper = styled.div`
  position: relative;
`;

export const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
`;

export const StyledIconsContainer = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: inherit;
  :hover {
    & > svg {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  border-radius: 2em;
  color: ${colors.white};
  :hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;
